import { render, staticRenderFns } from "./UploadPopup.vue?vue&type=template&id=4d8f4d38"
import script from "./UploadPopup.vue?vue&type=script&lang=js"
export * from "./UploadPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports